import React from 'react';
import { BRAND, isMarketGB } from '../../../constants/main';
import NeedHelpSectionStyledAC from './AC/NeedHelpSectionStyled.AC';
import NeedHelpSectionStyledAP from './AP/NeedHelpSectionStyled.AP';
import NeedHelpSectionStyledDS from './DS/NeedHelpSectionStyled.DS';
import NeedHelpSectionStyledOV from './OV/NeedHelpSectionStyled.OV';
import NeedHelpSectionStyledOV_GB from './OV/GB/NeedHelpSectionStyled.OV';
import { BrandTypes } from '../../../types/brands';
import { INeedHelpSectionProps } from './NeedHelpSectionTemplate';
import NeedHelpSectionStyled from './NeedHelpSectionStyled';

const NeedHelpSection = (props: INeedHelpSectionProps) => {
    switch (BRAND) {
        case BrandTypes.AC:
            return <NeedHelpSectionStyledAC {...props} />;
        case BrandTypes.AP:
            return <NeedHelpSectionStyledAP {...props} />;
        case BrandTypes.DS:
            return <NeedHelpSectionStyledDS {...props} />;
        case BrandTypes.OV:
            return isMarketGB ? <NeedHelpSectionStyledOV_GB {...props} /> : <NeedHelpSectionStyledOV {...props} />;
        default:
            return <NeedHelpSectionStyled {...props} />;
    }
};

export default NeedHelpSection;
